import SubCategoryScreenConnector from './SubCategoryScreenConnector';

export default SubCategoryScreenConnector;
